import './TurboTaxPage.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import Content from 'services/Content';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import { ReactComponent as CheckSquare } from 'assets/icons/check-square.svg';
import FinePrint from 'components/layouts/Preferences/Benefits/FinePrint';
import TurboTaxText from './TurboTaxText.js';
import { turboTaxGetStartedLink } from 'services/Externals';
import LinkWrapper from 'components/shared/LinkWrapper/LinkWrapper';
import {non529OnlyLRNTaxesDashboardAccountsBenefits} from 'services/FeatureFlags';
import LegalReferenceNumber from 'components/layouts/LegalReferenceNumber/LegalReferenceNumber';
import { GLOBALS } from 'services/globals';

const TurboTaxPage = () => {
  const turboTaxAccordionHeader = (
    <div className="flex-container">
      <div className="turbo-title-container">
        <div className="turbo-title-content">Get your taxes done right and</div>
        <div className="save-title">Save up to 20%</div>
        <div className="turbo-tax-federal">on TurboTax federal products</div>
      </div>
      <div className="turbo-tax-logo-container">
        <img src={`${GLOBALS.AAM_UI_EXTERNAL_BASE_URL}/content/dam/iinvestor/static-assets/intuit-turbotax.png`} alt="TurboTax Logo" />
      </div>
    </div>
  );

  return (
    <Fragment>
      <PreferencesHeader>
        <div className="preferences-benefits-header">
          TurboTax<sup>®</sup> Discounts
        </div>
      </PreferencesHeader>

      <div className="preferences-benefits-page">
        {turboTaxAccordionHeader}

        <div className="button-container">
          <LinkWrapper
            url={turboTaxGetStartedLink}
            title="Get Discount✝"
            className="save-now-button"
          />
        </div>

        <div
          className="turbo-tax-summary"
          dangerouslySetInnerHTML={{ __html: Content.turboTaxTableHead }}></div>
      </div>
      <div className="turbotax-marketing-page">
        <div className="turbo-tax-benefits-container">
          <div className="turbo-tax-marketing-title">TurboTax Benefits</div>
          <div className="turbo-tax-marketing-list-container">
            <div className="turbo-tax-marketing-list-item">
              <CheckSquare />{' '}
              <div>
                <strong>Taxes done right, your way:</strong> An expert in investment
                taxes can help or prepare your return from start to finish, or you
                can file on your own — TurboTax has you covered.
              </div>
            </div>
            <div className="turbo-tax-marketing-list-item">
              <CheckSquare />{' '}
              <div>
                <strong>100% accurate, 100% of the time:</strong> TurboTax guarantees
                calculations are always accurate, or they’ll pay any penalties.
              </div>
            </div>
            <div className="turbo-tax-marketing-list-item">
              <CheckSquare />{' '}
              <div>
                <strong>Always up-to-date:</strong>{' '}
                TurboTax is fully current on complex tax laws for your investments,
                including crypto and changing government credits — so you don’t have to be.
              </div>
            </div>
            <div className="turbo-tax-marketing-list-item">
              <CheckSquare />{' '}
              <div>
                <strong>Saves time and hassle:</strong>{' '}
                Import your T. Rowe Price investment info into TurboTax with ease to get your best tax outcome.
              </div>
            </div>
          </div>
        </div>

        <PreferencesRow className="turbo-tax-footer-copy">
          <TurboTaxText content={Content.turboTaxTableText} />
        </PreferencesRow>
      </div>

      <FinePrint
        className="turbo-tax-footer-copy"
        content={Content.turboTaxFooter}
      />
      {non529OnlyLRNTaxesDashboardAccountsBenefits() && (
          <LegalReferenceNumber />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  isDesktopLayout: state.view.isDesktopLayout,
  serviceType: state.customer.serviceType,
});

export default connect(mapStateToProps)(TurboTaxPage);
